import React from 'react';
import { Animation, Modal } from 'rsuite';
import './WidgetModalWindow.scss';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	content: JSX.Element;
}
export const WidgetModalWindow = (props: Props): React.ReactElement => {
	const { isOpen, onClose, content } = props;
	return (
		<Modal
			open={isOpen}
			onClose={onClose}
			animation={Animation.Fade}
			className="transparent-bg"
		>
			{content}
		</Modal>
	);
};
